import Sentence from './Sentence';

export default Sentence;
